<template>
  <div class="container">
    <div class="col-lg-6 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="login">
        <card class="card-login card-white text-left" style="border-radius: 10">
          <template slot="header">
            <img src="icons8-mail-200.png" class="card-img-email" alt="" />
            <!-- <h1 class="card-title">Log in</h1> -->
          </template>

          <div>
            <h1 class="card-title text-center">{{title}}</h1>
            <p class="text-center">
              {{body}}
              <a href="#">{{ email }}</a>
            </p>
            <!-- <base-input
              v-validate="'required|email'"
              name="email"
              v-model="model.email"
              placeholder="Email"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>

            <base-input
              v-validate="'required|min:5'"
              name="password"
              v-model="model.password"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input> -->
          </div>

          <div slot="footer">
            <base-button
              @click="verifyEmail()"
              native-type="submit"
              type="info"
              class="mb-3"
              size="lg"
              block
              v-if="disableButton"
            >
              Confirma Correo Electrónico
            </base-button>
            <!-- <div class="pull-left">
              <h6>
                <router-link class="link footer-link" to="/register">
                  Create Account
                </router-link>
              </h6>
            </div>

            <div class="pull-right">
              <h6><a href="#pablo" class="link footer-link">Need Help?</a></h6>
            </div> -->
          </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import { Card } from "@/components/index";
import axios from "axios";

export default {
  components: {
    Card,
  },
  data() {
    return {
      email: "",
      title: "Confirma tu Dirección de Correo Electrónico",
      body: "Para empezar a utilizar Impulso App, necesitamos verificar tu Dirección de Correo Electrónico",
      disableButton: true
    };
  },
  methods: {
    async login() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        // TIP use this.model to send it to api and perform login call
      }
    },
    verifyEmail() {
      const data = {
        userId: this.$route.query.userId,
      };
      axios
        .post(`https://rx0rkga0df.execute-api.us-east-1.amazonaws.com/user/confirm-email`, data)
        .then((response) => {
          console.log(response);
          this.title = "Tu Dirección de Correo Electrónico ha sido verificada.";
          this.body = "Puedes iniciar Impulso App, con Tu Dirección de Correo Electrónico";
          this.disableButton = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.email = this.$route.query.email;
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
